import { ReactComponent as Caution } from 'styles/images/icon_caution.svg';

const CheckFailModal = ({ open, onClose, content }) => {
  return (
    <div className={'modal-msg ' + (open ? 'active' : '')}>
      <div className='modal-msg-box check-name'>
        <div className='msg-box'>
          <Caution />
          <p className='title'>환자 정보 확인 실패</p>
          <div className='content'>
            {content?.split('\n').map((text) => (
              <p key={text}>{text}</p>
            ))}
          </div>
        </div>
        <div className='cmd'>
          <button type='button' className='btn_g3 btn_highlight' onClick={onClose}>
            확인
          </button>
        </div>
      </div>
    </div>
  );
};
export default CheckFailModal;
